module.exports = __webpack_public_path__ + "media/images/icon/icons8-VIP-152145d41dad1c9976d39fb00fa5faee.png";